import React from "react";
import { ArrowsClockwise, MagnifyingGlass } from "@phosphor-icons/react";

const CAPS = ["small", "mid", "large", "mega"];

export default function DashboardFilters({
  caps, onToggleCap,
  minVol, onMinVolChange,
  minPrice, onMinPriceChange,
  maxPrice, onMaxPriceChange,
  filter, onFilterChange,
  loading, onRefresh,
}) {
  return (
    <div className="flex items-center gap-3 flex-wrap">
      <div className="flex items-center gap-1 text-[10px] font-mono-data" data-testid="cap-filter">
        <span className="text-[#555] mr-1">CAP:</span>
        {CAPS.map((k) => {
          const active = caps[k];
          const cls = active ? "border-[#00e676] text-[#00e676]" : "border-[#222] text-[#555]";
          return (
            <button
              key={k}
              onClick={() => onToggleCap(k)}
              data-testid={`cap-${k}`}
              className={`px-2 py-0.5 border ${cls}`}
            >
              {k.toUpperCase()}
            </button>
          );
        })}
      </div>
      <div className="flex items-center gap-1 text-[10px] font-mono-data">
        <span className="text-[#555]">MIN VOL:</span>
        <input
          type="number" placeholder="1000000" value={minVol}
          onChange={(e) => onMinVolChange(e.target.value)} data-testid="min-vol"
          className="w-24 px-2 py-0.5 bg-[#0f0f0f] border border-[#222] outline-none"
        />
      </div>
      <div className="flex items-center gap-1 text-[10px] font-mono-data">
        <span className="text-[#555]">PRICE $:</span>
        <input
          type="number" placeholder="min" value={minPrice}
          onChange={(e) => onMinPriceChange(e.target.value)} data-testid="min-price"
          className="w-16 px-2 py-0.5 bg-[#0f0f0f] border border-[#222] outline-none"
        />
        <span className="text-[#555]">–</span>
        <input
          type="number" placeholder="max" value={maxPrice}
          onChange={(e) => onMaxPriceChange(e.target.value)} data-testid="max-price"
          className="w-16 px-2 py-0.5 bg-[#0f0f0f] border border-[#222] outline-none"
        />
      </div>
      <div className="flex items-center gap-2 px-3 py-1.5 border border-[#222] bg-[#0f0f0f]">
        <MagnifyingGlass size={14} className="text-[#555]" />
        <input
          data-testid="dashboard-filter"
          placeholder="filter ticker..."
          value={filter}
          onChange={(e) => onFilterChange(e.target.value)}
          className="bg-transparent outline-none text-xs font-mono-data placeholder:text-[#555] w-28"
        />
      </div>
      <button
        data-testid="dashboard-refresh"
        onClick={onRefresh}
        className="flex items-center gap-1 px-3 py-1.5 border border-[#222] hover:border-[#444] text-xs font-mono-data uppercase tracking-wider"
      >
        <ArrowsClockwise size={14} className={loading ? "animate-spin" : ""} /> Refresh
      </button>
    </div>
  );
}
